package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LocalFireDepartmentW500Rounded: ImageVector
    get() {
        if (_localFireDepartmentW500Rounded != null) {
            return _localFireDepartmentW500Rounded!!
        }
        _localFireDepartmentW500Rounded = Builder(name = "LocalFireDepartmentW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(249.65f, 790.39f)
                quadTo(155.22f, 696.0f, 155.22f, 560.0f)
                quadToRelative(0.0f, -112.76f, 67.0f, -217.36f)
                quadToRelative(67.0f, -104.6f, 184.24f, -183.79f)
                quadToRelative(24.87f, -17.15f, 51.59f, -1.86f)
                quadToRelative(26.73f, 15.29f, 26.73f, 46.36f)
                lineTo(484.78f, 252.0f)
                quadToRelative(0.0f, 31.97f, 22.12f, 53.59f)
                quadToRelative(22.11f, 21.63f, 54.1f, 21.63f)
                quadToRelative(16.28f, 0.0f, 30.83f, -7.13f)
                quadToRelative(14.56f, -7.13f, 25.82f, -20.44f)
                quadToRelative(8.93f, -11.11f, 22.88f, -13.89f)
                quadToRelative(13.95f, -2.78f, 25.9f, 5.94f)
                quadToRelative(64.44f, 46.43f, 101.4f, 117.51f)
                quadToRelative(36.95f, 71.07f, 36.95f, 150.79f)
                quadToRelative(0.0f, 136.0f, -94.43f, 230.39f)
                quadTo(615.91f, 884.78f, 480.0f, 884.78f)
                reflectiveQuadToRelative(-230.35f, -94.39f)
                close()
                moveTo(246.22f, 560.0f)
                quadToRelative(0.0f, 46.98f, 17.89f, 89.17f)
                quadToRelative(17.89f, 42.2f, 51.63f, 75.05f)
                quadToRelative(-0.76f, -3.81f, -0.76f, -6.85f)
                verticalLineToRelative(-6.85f)
                quadToRelative(1.43f, -30.32f, 13.55f, -56.77f)
                quadToRelative(12.12f, -26.45f, 34.17f, -48.49f)
                lineTo(480.0f, 489.72f)
                lineToRelative(117.54f, 115.54f)
                quadToRelative(22.05f, 22.04f, 34.17f, 48.49f)
                quadToRelative(12.12f, 26.45f, 13.31f, 56.77f)
                verticalLineToRelative(6.85f)
                quadToRelative(0.0f, 3.04f, -0.76f, 6.85f)
                quadToRelative(33.5f, -32.85f, 51.51f, -75.05f)
                quadToRelative(18.01f, -42.19f, 18.01f, -89.17f)
                quadToRelative(0.0f, -47.37f, -17.21f, -89.98f)
                quadToRelative(-17.21f, -42.61f, -49.77f, -76.13f)
                quadToRelative(-20.0f, 12.04f, -41.76f, 18.19f)
                quadToRelative(-21.76f, 6.14f, -44.04f, 6.14f)
                quadToRelative(-61.04f, 0.0f, -107.14f, -39.09f)
                reflectiveQuadToRelative(-56.45f, -97.65f)
                quadToRelative(-73.45f, 63.85f, -112.32f, 135.24f)
                quadToRelative(-38.87f, 71.4f, -38.87f, 143.28f)
                close()
                moveTo(480.0f, 617.26f)
                lineToRelative(-53.59f, 52.61f)
                quadToRelative(-10.34f, 10.33f, -15.99f, 23.48f)
                quadToRelative(-5.64f, 13.15f, -5.64f, 27.24f)
                quadToRelative(0.0f, 30.06f, 22.11f, 51.63f)
                quadToRelative(22.11f, 21.56f, 53.15f, 21.56f)
                quadToRelative(31.05f, 0.0f, 53.11f, -21.59f)
                quadToRelative(22.07f, -21.59f, 22.07f, -51.62f)
                quadToRelative(0.0f, -14.81f, -5.63f, -27.54f)
                quadToRelative(-5.62f, -12.74f, -15.94f, -23.12f)
                lineTo(480.0f, 617.26f)
                close()
            }
        }
        .build()
        return _localFireDepartmentW500Rounded!!
    }

private var _localFireDepartmentW500Rounded: ImageVector? = null
